;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const organizationQueryKeys = {
	all: ["organization"] as const,
	users: () => [...organizationQueryKeys.all, "users"] as const,
};

export const organizationMutationKeys = {
	deactivate: ["organization", "deactivate"] as const,
	edit: ["organization", "edit"] as const,
	requestPremiumUpgrade: (organizationId: string | undefined) =>
		["organization", organizationId, "request-premium-upgrade"] as const,
	usersEdit: ["organization", "users", "edit"] as const,
	usersRemove: ["organization", "users", "remove"] as const,
};
